import { getCurrentUrlParameter } from 'utils/url';
import { User } from './user';

export function applyDealerIdFromUrl(user: User): void {
  const dealerIdParam = getCurrentUrlParameter('dealerId');

  // Param is entirely absent from the URL — nothing to do
  if (dealerIdParam === undefined) {
    return;
  }

  // Param is present but empty, OR present with a value the user is authorised for
  let shouldCleanUrl = !dealerIdParam;

  if (dealerIdParam && user.dealerIdsList.includes(dealerIdParam)) {
    try {
      user.dealerId = dealerIdParam;
      shouldCleanUrl = true;
    } catch {
      // Setter threw (e.g. invalid brand letter) — leave URL unchanged
    }
  }

  if (shouldCleanUrl) {
    const url = new URL(window.location.href);
    url.searchParams.delete('dealerId');
    window.history.replaceState(null, '', url.toString());
  }
}
